import { render, staticRenderFns } from "./Beginpage.vue?vue&type=template&id=1582344e&scoped=true&"
import script from "./Beginpage.vue?vue&type=script&lang=js&"
export * from "./Beginpage.vue?vue&type=script&lang=js&"
import style0 from "./Beginpage.vue?vue&type=style&index=0&id=1582344e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1582344e",
  null
  
)

export default component.exports